<template>
  <v-menu v-model="notificationDrawer" :close-on-content-click="false" max-height="97vh">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" @click="getNotifications">
        <v-icon>mdi-email-outline</v-icon>
        <v-badge color="warning" :content="notificationCount" :value="notificationCount"></v-badge>
      </v-btn>
    </template>
    <v-card width="500">
      <v-card-title class="stickyTitle"
        >Notificaties
        <v-chip small class="ml-2">{{ notificationCount }}</v-chip>
        <v-spacer />
        <v-btn text @click.stop="notificationDrawer = !notificationDrawer" small><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-progress-linear v-if="fetchingNotifications" indeterminate color="primary" class="ma-0"></v-progress-linear>
      <v-card-text style="overflow-y: auto">
        <span v-if="notificationError" class="error--text">Er is een fout opgetreden bij het ophalen van de notificaties</span>
        <span v-else-if="!notificationCount && !fetchingNotifications">Er zijn geen nieuwe notificaties</span>
        <v-list v-else>
          <div v-for="(group, index) in sortedNotifications" :key="group.key">
            <v-list-item @click.stop="goToSubject(group.items[0])">
              <v-list-item-content>
                <v-row>
                  <v-col cols="10">
                    <v-list-item-title class="notification-title d-flex align-center text-wrap">
                      <span>{{ updateNotificationTitle(group.items[0]) }}</span>

                      <span v-if="isMessageNotification(group.items[0]) && group.items[0]?.title?.includes('[KLANT]')" class="notification-type primary--text ml-2">
                        <span class="notification-dot"></span>
                        nieuw klant-bericht
                      </span>

                      <v-chip v-if="group.items.length > 1" small outlined class="ml-2">
                        + {{ group.items.length - 1 }}
                      </v-chip>

                      <v-icon v-if="group.items[0]?.title?.startsWith('[URGENT]')" color="error" class="ma-0 ml-1" title="URGENT">
                        mdi-alert-circle
                      </v-icon>
                    </v-list-item-title>

                    <v-list-item-subtitle :title="group.items[0]?.shortBody">
                      {{ group.items[0]?.shortBody }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="notification-date text-caption text-wrap">
                      {{ $moment.utc(group.items[0]?.created).local().format('DD-MM HH:mm') }} <span class="date-separator">&bull;</span> {{
                        $moment.utc(group.items[0]?.created).fromNow(true) }} geleden
                    </v-list-item-subtitle>
                  </v-col>

                  <v-col cols="2" class="d-flex align-center justify-end">
                    <v-btn icon dense @click.stop="markAsRead(group.items[0].id)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-divider v-if="index < sortedNotifications.length - 1" />
          </div>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="notificationCount" text color="primary" small :loading="markingAllAsRead" @click.stop="markAllAsRead()"
          >Alles wissen</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import _ from "lodash";
export default {
  name: "NotificationListCard",
  data() {
    return {
      loading: false,
      notifications: [],
      notificationDrawer: false,
      notificationError: false,
      notificationCount: 0,
      markingAllAsRead: false,
      fetchingNotifications: false,
    };
  },
  computed: {
    sortedNotifications() {
      return Object.entries(this.notifications)
        .map(([key, items]) => ({
          key,
          items: [...items].sort((a, b) => new Date(b.created) - new Date(a.created)),
        }))
        .sort((a, b) => new Date(b.items[0]?.created) - new Date(a.items[0]?.created));
    },
  },
  methods: {
    updateNotificationTitle(notification) {
      return notification?.title
        ?.replace('[URGENT]', '')
        .replace('[KLANT]', '')
        .replace(/^\s*NIEUW BERICHT\s+/i, '')
        .trim();
    },
    isMessageNotification(notification) {
      return notification?.title?.toUpperCase().includes('NIEUW BERICHT');
    },
    getNotificationCount(retryCount = 0) {
      if (this.$root.tokenExpire && this.$root.tokenExpire > Date.now() / 1000) {
        this.$http
          .get("api/notification/count/")
          .then((response) => {
            this.notificationCount = response.data;
          })
          .catch((e) => {
            if (e.response && e.response.status === 401 && retryCount < 3) {
              setTimeout(() => {
                this.getNotificationCount(retryCount + 1);
              }, 1000);
            } else {
              console.log("notifications error!"); /* eslint-disable-line no-console */
            }
          });
      } else if (retryCount < 3) {
        setTimeout(() => {
          this.getNotificationCount(retryCount + 1);
        }, 1000);
      }
    },
    getNotifications(retryCount = 0) {
      this.fetchingNotifications = true;
      this.$http
        .get("api/notification/")
        .then((response) => {
          this.notificationError = false;
          this.notificationCount = response.data?.length;
          this.notifications = _.groupBy(response.data, (x) => x.objectId);
          this.fetchingNotifications = false;
        })
        .catch((e) => {
          if (e.response && e.response.status === 401 && retryCount < 3) {
            setTimeout(() => {
              this.getNotifications(retryCount + 1);
            }, 1000);
          } else {
            console.log("notifications error!"); /* eslint-disable-line no-console */
            this.notificationError = true;
            this.fetchingNotifications = false;
          }
        });
    },
    markAllAsRead() {
      this.markingAllAsRead = true;
      this.$http
        .get("api/notification/markallasread")
        .then(() => {
          this.getNotifications();
        })
        .catch((err) => {
          this.$root.$emit("display-error", "1200", err);
        })
        .finally(() => {
          this.markingAllAsRead = false;
          this.notificationDrawer = false;
        });
    },
    markAsRead(id) {
      if (!id) return;
      this.$http
        .get(`api/notification/markasread/${id}`)
        .then(() => {
          this.getNotifications();
        })
        .catch(() => {
          console.log("notification mark as read error!"); /* eslint-disable-line no-console */
        });
    },
    goToSubject(notification) {
      if (!notification) return;
      switch (notification.objectType) {
        case "Ticket":
          this.$router.push({ name: "Ticket", params: { id: notification.objectId } });
          break;
        case "Project":
          this.$router.push({ name: "Project", params: { id: notification.objectId } });
          break;
        case "Installation":
          this.$router.push({ name: "Installation", params: { id: notification.objectId } });
          break;
        default:
          break;
      }
      this.notificationDrawer = false;
      this.markAsRead(notification.id);
    },
  },
  mounted() {
    this.getNotificationCount();
    setInterval(() => this.getNotificationCount(), 300000);
  },
};
</script>

<style scoped>
.stickyTitle {
  position: sticky !important;
  top: 0 !important;
  z-index: 100 !important;
  background-color: white !important;
}

.notification-title {
  line-height: 1.4;
}

.notification-type {
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}

.notification-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-right: 4px;
  border-radius: 50%;
  background-color: currentColor;
  vertical-align: 1px;
}

.notification-date {
  color: #616161 !important;
}

.date-separator {
  padding: 0 3px;
}
</style>
